<script lang="ts">
  import Link from "../../../../common/link/Link.svelte";
  import pageUrl from "../../../../../PageUrl";

  const linkStyle = {
    textColor: "#5F89FF",
    hoverTextColor: "#5F89FF",
  };
</script>

<div class="text-[11px]">
  By Signing up, you agree to the
  <Link {...linkStyle} href={pageUrl.TERM_OF_SERVICE}>Terms of Service</Link>
  and
  <Link {...linkStyle} href={pageUrl.PRIVACY_POLICY}>Privacy Policy</Link>
  , including
  <Link {...linkStyle} href={pageUrl.COOKIE_USE}>Cookie Use</Link>.
</div>
